import { render, staticRenderFns } from "./stock-check.vue?vue&type=template&id=478ff938&scoped=true&"
import script from "./stock-check.vue?vue&type=script&lang=js&"
export * from "./stock-check.vue?vue&type=script&lang=js&"
import style0 from "./stock-check.vue?vue&type=style&index=0&id=478ff938&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ff938",
  null
  
)

export default component.exports